import React from 'react';
import { AiFillThunderbolt } from "react-icons/ai";
import { FaArrowRight } from "react-icons/fa6";

const HeroSection = ({ setActivePage }) => {
  return (
    <section className="hero">

      <div className="hero-overlay" />
      <div className="hero-bg-grid" />
      <div className="hero-bg-glow" />
      <div className="hero-bg-glow-2" />

      <div className="hero-inner">
        {/* ── LEFT: content ── */}
        <div className="hero-content">
          <div className="hero-tag">
            <i className="fa-regular fa-globe" /> Trusted Across 10+ Countries
          </div>

          <h1 className="hero-title">
            Accelerating Your<br />
            <span className="highlight">Digital Transformation</span>
          </h1>

          <p className="hero-desc">
            Inovaantage provides IT and geospatial solutions for utilities, telecom, and
            infrastructure sectors worldwide. Our deliverables in GIS, ADMS, SCADA, OSS/BSS, and
            workforce management solutions support efficient operations.
          </p>

          <div className="hero-actions">
            <button className="btn-primary" onClick={() => setActivePage("product-runr")}>
              Explore Products <FaArrowRight /><i className="fa-regular fa-arrow-right" />
            </button>
            <button className="btn-outline" onClick={() => setActivePage("contact")}>
              <i className="fa-regular fa-calendar-check" /> Request a Demo<FaArrowRight />
            </button>
          </div>

          <div className="hero-stats">
            <div className="stat">
              <span className="stat-num">10+</span>
              <span className="stat-label">Countries</span>
            </div>
            <div className="stat">
              <span className="stat-num">100%</span>
              <span className="stat-label">Migration Accuracy</span>
            </div>
            <div className="stat">
              <span className="stat-num">24/7</span>
              <span className="stat-label">Global Support</span>
            </div>
          </div>
        </div>

        {/* ── RIGHT: card (hidden on mobile via CSS) ── */}
        <div className="hero-visual">
          <div className="hero-card-stack">
            <div className="hero-main-card">
              <div className="hmc-header">
                <div className="hmc-icon" ><AiFillThunderbolt /></div>
                <div>
                  <div className="hmc-title">rUNr® Migration Platform</div>
                  <div className="hmc-sub">ESRI Utility Network Migration</div>
                </div>
              </div>
              <div className="hmc-metrics">
                <div className="hmc-metric">
                  <div className="hmc-metric-val">99.99%</div>
                  <div className="hmc-metric-label">Accuracy</div>

                  <svg className="mini-line-chart" viewBox="0 0 160 70">
                    <defs>
                      <linearGradient id="lineFill" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ff4b12" stopOpacity="0.25" />
                        <stop offset="100%" stopColor="#ff4b12" stopOpacity="0" />
                      </linearGradient>
                    </defs>

                    <path
                      d="M8 60 L25 52 L42 55 L58 42 L74 46 L92 35 L108 40 L126 24 L145 30 L155 18 L155 70 L8 70 Z"
                      fill="url(#lineFill)"
                    />

                    <polyline
                      points="8,60 25,52 42,55 58,42 74,46 92,35 108,40 126,24 145,30 155,18"
                      fill="none"
                      stroke="#ff4b12"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div className="hmc-metric">
                  <div className="hmc-metric-val">70–90%</div>
                  <div className="hmc-metric-label">Time Saved</div>

                  <div className="mini-bar-chart">
                    <span style={{ height: "18px" }}></span>
                    <span style={{ height: "30px" }}></span>
                    <span style={{ height: "24px" }}></span>
                    <span style={{ height: "38px" }}></span>
                    <span style={{ height: "55px" }}></span>
                    <span style={{ height: "72px" }}></span>
                  </div>
                </div>
              </div>
              {[
                { label: "Data Integrity", pct: "98%", val: 98 },
                { label: "Migration Automation", pct: "95%", val: 95 },
                { label: "Zero Downtime", pct: "100%", val: 100 },
              ].map((b, i) => (
                <div key={i}>
                  <div className="hmc-bar-row">
                    <span>{b.label}</span>
                    <span style={{ color: "rgb(249, 66, 0)" }}>{b.pct}</span>
                  </div>
                  <div className="hmc-bar">
                    <div className="hmc-bar-fill" style={{ width: b.pct }} />
                  </div>
                </div>
              ))}
            </div>
            <div className="hero-floating-badge" style={{ top: "-20px", right: "-20px", animationDelay: "1s" }}>
              <div className="badge-dot" />
              <div>
                <div className="badge-text">ISO 27001</div>
                <div className="badge-sub">Certified</div>
              </div>
            </div>
            <div className="hero-floating-badge" style={{ bottom: "-20px", left: "-20px", animationDelay: "2s" }}>
              <div className="badge-dot" style={{ background: "rgb(249, 66, 0)" }} />
              <div>
                <div className="badge-text">GDPR Compliant</div>
                <div className="badge-sub">Data Protection</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {videoError && (
        <div style={{ position: "absolute", bottom: 10, right: 10, fontSize: 12, color: "rgba(255,255,255,0.5)", background: "rgba(0,0,0,0.5)", padding: "4px 8px", borderRadius: 20, zIndex: 10 }}>
          Video fallback
        </div>
      )} */}
    </section>
  );
};

export default HeroSection;
